import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Button,
  TablePagination,
  TextField,
  InputAdornment,
  IconButton,
} from '@material-ui/core';

import Api from '../../../libraries/api';
import user from '../../../images/menu/avatar.svg';
import TablePaginationActions from '../../presentational/table-pagination-actions';
import { history } from '../../../shared/configure-store';
import AuthHelper from '../../../libraries/auth-helper';

class Customers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            loadingButton: false,
            showDialog: false,
            errors: {},
            orderBy: 'id',
            sortedBy: '',
            searchBy: null,
            level: null,
            levels: [],
            companies: [],
            rows: [],
            total: 0,
            perPage: 500,
            currentPage: 0,
            nextPage: 0,
            currentPageTable: 0,
            isManage: false,
        };
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        document.title = 'Gudangemas - Customer';
        const profile = AuthHelper.getProfile();
        if (profile['map-menu']) {
            const roles = profile['map-menu'].map(o => ({
                id: o.id,
                name: o.menu.name,
                isCreate: o.isCreate,
                isManage: o.isManage,
            }));
            const all = roles.filter(item => item.name === 'Customer');
            this.setState({ isManage: all.length > 0 && all[0].isManage });
        }
    
        const path = this.props.match.path;
        const customerType = path.indexOf('individual') > -1 ? 'INDIVIDU' : 'CORPORATE';
        this.setState({ customerType }, () => this.__fetchData(false));
    
        Api.get('/lookup/by-group-id/1')
            .then(resp => this.setState({ levels: resp.data, loading: false }))
            .catch(err => console.log(err));

        this.__fetchCompanies();
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.path !== prevProps.match.path) {
            const path = this.props.match.path;
            const customerType = path.indexOf('individual') > -1 ? 'INDIVIDU' : 'CORPORATE';
            this.setState({ customerType }, () => this.__fetchData(false));
        }
    }

    __fetchData = (update) => {
        this.setState({ loading: true });

        const params = {
            page: update ? 0 : this.state.currentPage,
            size: this.state.perPage,
            'search-by': this.state.searchBy,
            'level-id': this.state.level,
            'company-id': this.state.companyId,
            'type-of-customer': this.state.customerType,
            sort: [{
                'column-name': this.state.orderBy,
                'is-ascending': this.state.sortedBy === 'asc',
            }],
        };
    
        Api.post('/customer/get-all', params)
            .then(resp => this.setState({
                rows: resp.data.customers,
                total: resp.data.totalItems,
                currentPageTable: resp.data.currentPage,
                currentPage: resp.data.currentPage,
                nextPage: resp.data.currentPage + 1,
                loading: false,
            }))
            .catch(err => this.setState({ errors: err, loading: false }));
    };

    __fetchCompanies = () => {
        const companyParams = {
            page: 0,
            size: 1000,
        };

        Api.post('/company/find-all', companyParams)
            .then(resp => {
                if (resp.data) {
                    this.setState({ companies: resp.data.content });
                }
            });
    };

    handleSearch = () => this.__fetchData(true);

    handleKeyDown = (e) => e.key === 'Enter' && this.__fetchData(true);

    handleSort = (val) => {
        const { sortedBy } = this.state;
        let newSortedBy = 'asc';
        if (val === this.state.orderBy) {
            newSortedBy = sortedBy === 'asc' ? 'desc' : 'asc';
        }
        this.setState(
            { orderBy: val, sortedBy: newSortedBy, loading: true },
            () => this.__fetchData(false)
        );
    };

    handleChange = (e, prop) => this.setState({ [prop]: e.target.value });

    handleChangeSelect = (e, prop) => this.setState({ [prop]: e.target.value }, () => this.__fetchData(true));
        
    handleOpen = (row) => {
        this.setState({
            showDialog: true,
            idDelete: row['id-customer'],
            currDelete: `${row['full-name']} ${row.email}`,
        });
    };

    handleClose = () => this.setState({ showDialog: false });

    handleDelete = () => {
        if (!this.state.idDelete) return;

        const params = { listId: [this.state.idDelete] };
        Api.delete('/customer', params)
            .then(() => {
                this.setState({ showDialog: false });
                this.showMessage(true, 'Customer berhasil dihapus');
                this.__fetchData(true);
            })
            .catch(() => this.setState({ showDialog: false }));
    };

    showMessage = (status, message) => toast[status ? 'success' : 'error'](message, { position: toast.POSITION.BOTTOM_RIGHT });

    handleChangePage = (_, newPage) =>
        this.setState(
            { rows: [], currentPage: newPage, currentPageTable: newPage, loading: true },
            () => this.__fetchData(false)
        );

    handleChangeRowsPerPage = (e) =>
        this.setState(
            { perPage: parseInt(e.target.value, 10), currentPage: 1, loading: true },
            () => this.__fetchData(false)
        );

    handleGo = (link) => history.push(link);

    handleExport = () => {
        this.setState({ loadingButton: true });

        const path = this.props.match.path;
        let customerType = 'CORPORATE';
        if (path.indexOf('individual') > -1) {
            customerType = 'INDIVIDU';
        }

        const params = {
            size: 500,
            page: this.state.currentPage,
            'type-of-customer': customerType,
            sort: [{
                'column-name': this.state.orderBy,
                'is-ascending': this.state.sortedBy === 'asc',
            }],
        };

        Api.postEx('/customer/export/excel', params, 'blob')
            .then(res => res.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'customers.xlsx';
                a.click();
            })
            .finally(() => this.setState({ loadingButton: false }));
    };

    render() {
        return (
            <div className="row main-content">
                <div className="col-12">
                    <h1 className="page-title">Customers</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Customers</li>
                        </ol>
                    </nav>
                </div>

                <div className="col-12">
                    <div className="table-wrapper">
                        <div className="row align-items-center content-title">
                            <div className="col-6">
                                <h2 className="mb-0">{this.state.customerType === 'INDIVIDU' ? 'Daftar Customer Individu' : 'Daftar Customer Corporate'}</h2>
                            </div>
                            <div className="col-6 text-right">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className="mr-2"
                                    onClick={() => this.handleGo('/customers/reset')}
                                >
                                    Reset Password
                                </Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={this.handleExport}
                                    disabled={this.state.loadingButton}
                                >
                                    <i className="fas fa-file-excel mr-2"></i>
                                    Export {this.state.loadingButton && <i className="fa fa-spinner fa-spin"></i>}
                                </Button>
                            </div>
                        </div>

                        <div className="row align-items-center justify-content-between content-filter">
                            <div className="col-md-6 col-lg-4 mb-2 mb-md-0">
                                <TextField
                                    id="input-with-icon-textfield"
                                    variant="outlined"
                                    className="search-field"
                                    onChange={(e) => this.handleChange(e, 'searchBy')}
                                    onKeyDown={this.handleKeyDown}
                                    onBlur={this.handleSearch}
                                    placeholder="Search here"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="start">
                                                <IconButton onClick={this.handleSearch}><i className="fas fa-search"></i></IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </div>
                            {this.state.customerType === 'CORPORATE' && (
                                <div className="col-md-6 col-lg-4 text-md-right">
                                    <TextField
                                        variant="outlined"
                                        id="companyId"
                                        name="companyId"
                                        label="Company"
                                        onChange={(e) => this.handleChangeSelect(e, 'companyId')}
                                        value={this.state.companyId}
                                        select
                                        fullWidth
                                    >
                                        <MenuItem value="">Semua</MenuItem>
                                        {this.state.companies.map(option => (<MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>))}
                                    </TextField>
                                </div>
                            )}
                            <div className="col-md-6 col-lg-4 text-md-right">
                                <TextField
                                    variant="outlined"
                                    select
                                    id="level"
                                    name="level"
                                    label="Level"
                                    onChange={(e) => this.handleChangeSelect(e, 'level')}
                                    value={this.state.level}
                                    fullWidth
                                >
                                    <MenuItem value="">Semua</MenuItem>
                                    {this.state.levels.map(option => (<MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>))}
                                </TextField>
                            </div>
                        </div>
                        <div className="table-list row">
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{ minWidth: 200 }} className="clickable" onClick={() => this.handleSort('username')}>
                                            User Name
                                            {this.state.orderBy === 'username' && (<span className="icon-sort">{this.state.sortedBy === 'asc' ? <i className="fas fa-sort-up"></i> : <i className="fas fa-sort-down"></i>}</span>)}
                                        </TableCell>
                                        {this.state.customerType === 'INDIVIDU' && (
                                            <TableCell className="clickable" onClick={() => this.handleSort('fullName')}>
                                                Full Name
                                                {this.state.orderBy === 'fullName' && (<span className="icon-sort">{this.state.sortedBy === 'asc' ? <i className="fas fa-sort-up"></i> : <i className="fas fa-sort-down"></i>}</span>)}
                                            </TableCell>
                                        )}
                                        {this.state.customerType === 'CORPORATE' && (
                                            <TableCell className="clickable" onClick={() => this.handleSort('companyName')}>
                                                Company Name
                                                {this.state.orderBy === 'companyName' && (<span className="icon-sort">{this.state.sortedBy === 'asc' ? <i className="fas fa-sort-up"></i> : <i className="fas fa-sort-down"></i>}</span>)}
                                            </TableCell>
                                        )}
                                        <TableCell className="clickable" onClick={() => this.handleSort('email')}>
                                            Email
                                            {this.state.orderBy === 'email' && (<span className="icon-sort">{this.state.sortedBy === 'asc' ? <i className="fas fa-sort-up"></i> : <i className="fas fa-sort-down"></i>}</span>)}
                                        </TableCell>
                                        {this.state.customerType === 'CORPORATE' && (<TableCell>Regional</TableCell>)}
                                        {this.state.customerType === 'INDIVIDU' && (<TableCell>Level</TableCell>)}
                                        <TableCell>Created Date</TableCell>
                                        <TableCell style={{ minWidth: 100 }}>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.loading ? (
                                        <TableRow>
                                            <TableCell colSpan={9} align="center" className="py-5"><CircularProgress color="primary" /></TableCell>
                                        </TableRow>
                                    ) : this.state.rows.length === 0 ? (
                                        <TableRow style={{ height: 33 * this.state.perPage }}>
                                            <TableCell colSpan={6} style={{ textAlign: 'center' }}>Data Customer kosong</TableCell>
                                        </TableRow>
                                    ) : (
                                        this.state.rows.map((row) => (
                                            <TableRow key={row['id-customer']} selected={row.selected}>
                                                <TableCell>
                                                    <img src={row.avatar || user} className="img-user mr-2" alt="avatar" />
                                                    <span>{row.username || ''}</span>
                                                </TableCell>
                                                {this.state.customerType === 'INDIVIDU' && (<TableCell>{row['full-name'] || ''}</TableCell>)}
                                                {this.state.customerType === 'CORPORATE' && (<TableCell>{row['companyName'] || ''}</TableCell>)}
                                                <TableCell>{row.email || ''}</TableCell>
                                                {this.state.customerType === 'CORPORATE' && (<TableCell>{row['regional-code'] || ''}{row['regional-name'] ? ' - '+row['regional-name'] : ''}</TableCell>)}
                                                {this.state.customerType === 'INDIVIDU' && (<TableCell>{row.level || ''}</TableCell>)}
                                                <TableCell>{row['created-date'] || ''}</TableCell>
                                                <TableCell className="action-menu">
                                                    <button className="btn-icon"><i className="fas fa-ellipsis-v"></i></button>
                                                    <div className="action-wrap">
                                                        <Link to={`/customers/edit/${row['id-customer']}`} className="btn-icon mb-2"><i className="fas fa-pencil-alt"></i> Ubah</Link>
                                                        {this.state.isManage && (<button className="btn-icon" onClick={() => this.handleOpen(row)}><i className="fas fa-trash-alt"></i> Hapus</button>)}
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    )}
                                </TableBody>
                            </Table>
                        </div>
                        <TablePagination
                            rowsPerPageOptions={[100, 250, 500]}
                            component="div"
                            count={this.state.total}
                            rowsPerPage={this.state.perPage}
                            page={this.state.currentPageTable}
                            backIconButtonProps={{ 'aria-label': 'previous page' }}
                            nextIconButtonProps={{ 'aria-label': 'next page' }}
                            onChangePage={this.handleChangePage}
                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                            ActionsComponent={TablePaginationActions}
                        />
                    </div>
                    <Dialog
                        maxWidth="sm"
                        fullWidth
                        open={this.state.showDialog}
                        onClose={this.handleClose}
                        aria-labelledby="form-dialog-title"
                    >
                        <DialogTitle id="form-dialog-title">KONFIRMASI</DialogTitle>
                        <DialogContent>
                            <p>Apakah anda yakin akan menghapus <strong>{this.state.currDelete}</strong>?</p>
                        </DialogContent>
                        <DialogActions>
                            <button className="btn btn-blue-trans" onClick={this.handleClose}>Batal</button>
                            <button className="btn btn-blue" onClick={this.handleDelete}>Hapus</button>
                        </DialogActions>
                    </Dialog>
                    <ToastContainer />
                </div>
            </div>
        );
    }
}

export default Customers;